module.exports = __webpack_public_path__ + "images/112_160.jpg";